import {NavLink, Outlet} from 'react-router-dom';

import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';
import styles from './rewardSchemes.module.scss';

const REWARD_BANKS_SUBTABS = [
  {key: 'stocks-bank', to: '/dashboard/reward-banks', name: 'Stocks Bank'},
  {key: 'cash-bank', to: '/dashboard/reward-banks/cash', name: 'Cash Bank'},
];

const RewardBanksManagement = () => {
  const {visibleSubTabs} = useVisibleSubTabs(
    NavTabsEnum.RewardBanks,
    REWARD_BANKS_SUBTABS,
  );

  return (
    <div className={styles.page}>
      <h1 className={styles.pageTitle}>Reward banks</h1>
      <p className={styles.pageSubtitle}>
        The stock and cash set aside to pay out user rewards.
      </p>

      {/* A segmented strip rather than the shared CustomLink: that component
          carries the sidebar's own styling, so these two rendered as chunky
          purple blocks with no sense of which was selected. */}
      <nav className={styles.tabs}>
        {visibleSubTabs.map(tab => (
          <NavLink
            key={tab.key}
            to={tab.to}
            // Only the index tab needs an exact match — without `end` the
            // stocks tab stays highlighted while /cash is open, since its
            // path is a prefix of it.
            end={tab.to === '/dashboard/reward-banks'}
            className={({isActive}) =>
              `${styles.tab} ${isActive ? styles.tabActive : ''}`.trim()
            }>
            {tab.name}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
};

export {RewardBanksManagement};
